import React from 'react';
import { motion } from 'framer-motion';
import { GlowButton } from './GlowButton';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-97">
      {/* Animated psychedelic background gradients — reduced on mobile */}
      <div className="absolute inset-0 gpu-layer" data-id="element-98">
        <div className="absolute top-0 left-1/4 w-[300px] sm:w-[600px] h-[300px] sm:h-[600px] bg-flame/10 rounded-full blur-[80px] sm:blur-[150px] animate-pulse" data-id="element-99" />
        <div className="absolute bottom-0 right-1/4 w-[250px] sm:w-[500px] h-[250px] sm:h-[500px] bg-magenta/10 rounded-full blur-[60px] sm:blur-[120px] animate-pulse" style={{
        animationDelay: '1.5s'
      }} data-id="element-100" />
        <div className="hidden sm:block absolute top-1/3 right-1/3 w-[400px] h-[400px] bg-teal/10 rounded-full blur-[100px] animate-pulse" style={{
        animationDelay: '3s'
      }} data-id="element-101" />
        <div className="hidden sm:block absolute bottom-1/3 left-1/3 w-[350px] h-[350px] bg-purple-electric/8 rounded-full blur-[120px] animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-102" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32 flex flex-col lg:flex-row items-center gap-16 lg:gap-20" data-id="element-103">
        {/* Text content */}
        <div className="flex-1 text-center lg:text-left" data-id="element-104">
          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-8" data-id="element-105">
            ¿Y si Dios no estuviera en el cielo?{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-flame via-gold-light to-flame-light" data-id="element-106">
              sino en tu glándula pineal?
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-sans text-lg sm:text-xl text-white/60 leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-107">
            Un viaje interior hacia el Todo. El libro que une la neurociencia
            con la sabiduría ancestral de la Ayahuasca.
          </motion.p>

          {/* Format badges */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex items-center gap-3 mb-10 justify-center lg:justify-start" data-id="element-108">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.05] backdrop-blur-sm border border-white/[0.08] text-white/70 text-sm font-sans" data-id="element-109">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-flame-light" data-id="element-110">
                <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" data-id="element-111" />
              </svg>
              Ebook
            </span>
            <span className="text-white/20 text-xs" data-id="element-112">+</span>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.05] backdrop-blur-sm border border-white/[0.08] text-white/70 text-sm font-sans" data-id="element-113">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-purple-electric-light" data-id="element-114">
                <path d="M3 18v-6a9 9 0 0 1 18 0v6" data-id="element-115" />
                <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" data-id="element-116" />
              </svg>
              Audiobook
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-117">
            <GlowButton href="#obtener-pack" variant="gold" data-id="element-118">
              Quiero comenzar el viaje
            </GlowButton>
          </motion.div>
        </div>

        {/* Book cover image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex-shrink-0" data-id="element-119">
          <div className="relative animate-float gpu-layer" data-id="element-120">
            {/* Psychedelic aura — simplified on mobile */}
            <div className="absolute -inset-8 sm:-inset-12 bg-gradient-to-br from-flame/30 via-magenta/20 to-teal/25 rounded-3xl blur-2xl sm:blur-3xl animate-pulse" data-id="element-121" />
            <div className="hidden sm:block absolute -inset-8 bg-gradient-to-tr from-purple-electric/20 via-flame/15 to-gold/20 rounded-2xl blur-2xl" data-id="element-122" />
            <div className="hidden sm:block absolute -inset-4 bg-gradient-to-bl from-teal/15 via-magenta/10 to-flame/15 rounded-xl blur-xl" data-id="element-123" />

            {/* Book image container */}
            <div className="relative w-56 sm:w-72 rounded-lg overflow-hidden shadow-glow-psyche animate-psyche-pulse" data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/tMPwTWnudTgzcXXb9s6Bxw/Screenshot_2026-02-19_at_12.48.38_PM.png" alt="DMT: La Molécula de Dios - Portada del libro" loading="eager" decoding="async" fetchPriority="high" className="w-full h-auto object-cover rounded-lg" data-id="element-125" />
              <div className="absolute inset-0 bg-gradient-to-t from-void/20 via-transparent to-transparent pointer-events-none" data-id="element-126" />
            </div>

            {/* Fractal particles — fewer on mobile */}
            <div className="absolute -top-4 -right-4 w-3 h-3 bg-flame rounded-full blur-sm animate-pulse" data-id="element-127" />
            <div className="absolute -bottom-5 -left-3 w-2.5 h-2.5 bg-magenta rounded-full blur-sm animate-pulse" style={{
            animationDelay: '0.5s'
          }} data-id="element-128" />
            <div className="hidden sm:block absolute top-1/4 -right-6 w-2 h-2 bg-teal-light rounded-full blur-sm animate-pulse" style={{
            animationDelay: '1s'
          }} data-id="element-129" />
            <div className="hidden sm:block absolute bottom-1/4 -left-5 w-2 h-2 bg-purple-electric-light rounded-full blur-sm animate-pulse" style={{
            animationDelay: '1.5s'
          }} data-id="element-130" />
            <div className="hidden sm:block absolute top-1/2 -right-8 w-1.5 h-1.5 bg-gold-light rounded-full blur-sm animate-pulse" style={{
            animationDelay: '2s'
          }} data-id="element-131" />
            <div className="hidden sm:block absolute -top-2 left-1/4 w-1.5 h-1.5 bg-flame-bright rounded-full blur-sm animate-pulse" style={{
            animationDelay: '2.5s'
          }} data-id="element-132" />
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-133">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-5 h-8 rounded-full border border-flame/40 flex items-start justify-center p-1.5" data-id="element-134">
          <div className="w-1 h-2 bg-flame/60 rounded-full" data-id="element-135" />
        </motion.div>
      </motion.div>
    </section>;
}
// tailwind.config.js
export default {
  theme: {
    extend: {
      colors: {
        void: {
          DEFAULT: '#0a0a0a',
          light: '#111111',
          lighter: '#1a1a1a'
        },
        'purple-electric': {
          DEFAULT: '#8b5cf6',
          deep: '#6d28d9',
          light: '#a78bfa',
          glow: 'rgba(139, 92, 246, 0.15)'
        },
        gold: {
          DEFAULT: '#d4a853',
          warm: '#b8860b',
          light: '#e8c97a',
          glow: 'rgba(212, 168, 83, 0.15)'
        },
        astral: {
          DEFAULT: '#3b82f6',
          deep: '#2563eb',
          light: '#60a5fa',
          glow: 'rgba(59, 130, 246, 0.15)'
        },
        // New psychedelic colors from the book cover
        flame: {
          DEFAULT: '#e85d04',
          light: '#f48c06',
          bright: '#ff6b35',
          glow: 'rgba(232, 93, 4, 0.2)'
        },
        teal: {
          deep: '#0d5c63',
          light: '#2dd4bf',
          glow: 'rgba(26, 112, 112, 0.15)'
        }
      }
    }
  }
};